export default __webpack_public_path__ + "static/media/spinach.8b9c6d67.jpg";